<template>
    <AdminSection :title="title">
        <Module
            type="container"
            :sort="1"
            :pointer-events="false"
            class="mb-5 last:mb-0"
            ref="moduleContainer"
        />
    </AdminSection>
</template>

<script>
import {provide} from "vue";

export default {
    props: {
        location: {
            type: String,
            default: 'default',
        },
        title: {
            type: String,
            default: 'Modules'
        }
    },

    setup(props) {
        provide('location', props.location);
    }
}
</script>
